import { ConditionComparison, ValueSource, } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/Condition';
import { Output, OutputTypeStateId } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/Output';
import { ConditionViewModel } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/viewModels/ConditionViewModel';
import { v4 as uuid } from 'uuid';
export class OutputViewModel extends Output {
    static $inject = ['init'];
    constructor(init) {
        super();
        Object.assign(this, init);
    }
    static create(stateId, $connId, $id, typeOfStateId, $contentId) {
        return new OutputViewModel({
            stateId,
            typeOfStateId: (typeOfStateId ?? OutputTypeStateId.State),
            $connId,
            $contentId,
            $id: $id || uuid(),
            conditions: [
                new ConditionViewModel({
                    source: ValueSource.Input,
                    comparison: ConditionComparison.Exists,
                    values: [],
                }),
            ],
        });
    }
    static createFromContentOption(contentId, option) {
        const output = this.create();
        output.$contentId = contentId;
        output.conditions = [
            new ConditionViewModel({
                source: ValueSource.Input,
                comparison: ConditionComparison.Equals,
                values: [option],
            }),
        ];
        return output;
    }
    static createFromContentOptions(contentId, options) {
        const output = this.create();
        output.$contentId = contentId;
        output.conditions = [
            new ConditionViewModel({
                source: ValueSource.Input,
                comparison: ConditionComparison.Equals,
                values: options,
            }),
        ];
        return output;
    }
    static defineTypeOfStateId(stateId) {
        return OutputViewModel.isVariableValue(stateId) ? OutputTypeStateId.Variable : OutputTypeStateId.State;
    }
    static isVariableValue(stateId) {
        return stateId && stateId.startsWith('{{') && stateId.endsWith('}}');
    }
}
